import React from 'react';
import BottomBar from './BottomBar';
const Foreground = ({
  accent_color,
  accent_text_color,
  logo,
  metadata
}) => {
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return /*#__PURE__*/React.createElement("div", {
    className: "Foreground"
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: accent_text_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default Foreground;